import { memo } from 'react';
import { useSignalRHubsSetup } from '../hooks/useSignalRHubsSetup';
import { useConfigureAxios } from '../hooks/useConfigureAxios';
import { useAppUpdateWatcher } from '../hooks/useAppUpdateWatcher';

export const Setup = memo(() => {
  useSignalRHubsSetup();
  useConfigureAxios();
  useAppUpdateWatcher();
  return null;
});
